import React from 'react';
import { useSetRecoilState } from 'recoil';
import * as AppState from '../../../../AppState';

const SortPropertyCards = () => {
	const setGsSearchSort = useSetRecoilState(AppState.gsPropertyListSort);

	const Default =
		<React.Fragment key='Default'>
			<li role="menuitem" tabIndex={0} className="d-flex align-items-center cursor--pointer dropdown-item" onClick={() => setGsSearchSort(0)}>
        Default
			</li>
		</React.Fragment>;

	const Newest =
		<React.Fragment key='Newest'>
			<li role="menuitem" tabIndex={0} className="d-flex align-items-center cursor--pointer dropdown-item" onClick={() => setGsSearchSort(1)}>
				Newest
			</li>
		</React.Fragment>;

	const PriceDesc =
		<React.Fragment key='PriceDesc'>
			<li role="menuitem" tabIndex={0} className="d-flex align-items-center cursor--pointer dropdown-item" onClick={() => setGsSearchSort(2)}>
				Price Descending
			</li>
		</React.Fragment>;

	const PriceAsc =
		<React.Fragment key='PriceAsc'>
			<li role="menuitem" tabIndex={0} className="d-flex align-items-center cursor--pointer dropdown-item" onClick={() => setGsSearchSort(3)}>
				Price Ascending
			</li>
		</React.Fragment>;


	return (
		<React.Fragment>
      {Default}
			{Newest}
			{PriceDesc}
			{PriceAsc}
		</React.Fragment>
	);
};

export default SortPropertyCards;
